'use client'

import { Button, Image, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { PRO_INTEGRATIONS_PATH } from '../../../constants/routes'

const ProIntegrations = () => {
  const translate = useTranslate('business.homepage.pro_integrations')
  const asset = useAsset('/assets/business-accounts/')

  return (
    <section
      className="business-accounts__pro-integrations"
      data-testid="business-accounts-pro-integrations"
    >
      <div className="container business-accounts__pro-integrations-inner">
        <div className="business-accounts__pro-integrations-content">
          <h2
            className="c-text--responsive-small-heading c-text--inverse"
            data-testid="business-accounts-pro-integrations-title"
          >
            {translate('title')}
          </h2>
          <Spacer size={Spacer.Size.Medium} />
          <p
            className="c-text--responsive-small-body c-text--inverse"
            data-testid="business-accounts-pro-integrations-description"
          >
            {translate('description')}
          </p>
          <Spacer size={Spacer.Size.X2Large} />
          <div className="business-accounts__pro-integrations-cta">
            <Button
              styling={Button.Styling.Outlined}
              text={translate('action')}
              url={PRO_INTEGRATIONS_PATH}
              inverse
              testId="business-accounts-pro-integrations-button"
            />
          </div>
        </div>
        <Spacer size={Spacer.Size.X4Large} orientation={Spacer.Orientation.Vertical} />
        <div className="business-accounts__pro-integrations-image">
          <Image
            src={asset('pro-integrations.png')}
            scaling={Image.Scaling.Cover}
            loading="lazy"
            testId="business-accounts-pro-integrations-image"
          />
        </div>
      </div>
    </section>
  )
}

export default ProIntegrations
